import {forwardRef} from 'react'

import {twMerge} from '@sdox/utils'

import type {ClassNameValue} from 'tailwind-merge'
import type {ReactNode} from 'react'

export interface MainProps {
  className?: ClassNameValue
  children?: ReactNode
}

export const Main = forwardRef<HTMLDivElement, MainProps>(({children, className, ...restProps}, outerRef) => (
  <main
    ref={outerRef}
    className={twMerge(
      'min-h-screen w-full bg-surface-secondary',
      'flex flex-col items-center',
      'pt-spacing-72 sm:p-spacing-32 sm:pt-spacing-72 md:px-spacing-32 md:pt-spacing-88',
      // border radius of sections should be 0 when <main> does not have padding
      //  and --radius-lg when <main> has padding.
      // The logic is in this file instead of baseStyle.scss so it has close coupling with the padding css class.
      '[--radius-section:0] sm:[--radius-section:var(--radius-lg)]',
      className,
    )}
    {...restProps}
  >
    {children}
  </main>
))

Main.displayName = 'Main'
